(() => {
  // app/scripts/infinite-load.js
  customElements.define("infinite-loading", class extends HTMLElement {
    constructor() {
      super();
      this.submitBtn = this.querySelector("button");
      this.submitBtn.addEventListener("click", (e) => {
        this.fetch();
      });
      let storage = sessionStorage.getItem("collection_cookie");
      this.check = true;
      if (this.check && storage != null) {
        this.fetch();
      }
    }
    scroll(scrollToEl) {
      const topOfElement = window.scrollY + scrollToEl.getBoundingClientRect().top - document.querySelector(".header-section").offsetHeight;
      window.scroll({ top: topOfElement, behavior: "smooth" });
    }
    async fetch() {
      const url = this.dataset.url;
      this.loading();
      await fetch(url).then((e) => e.text()).then((e) => {
        this.closest(".group-pagination").remove();
        const div = document.createElement("div");
        div.innerHTML = e;
        const containerClassName = this.dataset.container.includes(".") ? this.dataset.container : "#" + this.dataset.container;
        const container = document.querySelector(containerClassName);
        const containerProduct = document.querySelector(`${containerClassName} .list-products`);
        containerProduct.innerHTML += div.querySelector(`${containerClassName} .list-products`).innerHTML;
        let storage = sessionStorage.getItem("collection_cookie");
        if (storage != null) {
          storage = JSON.parse(storage);
          document.querySelectorAll(".list-products  product-card").forEach((e2) => {
            if (e2.dataset.productId == storage.id) {
              e2.classList.add("active");
              this.scroll(e2);
              sessionStorage.removeItem("collection_cookie");
              this.check = false;
            }
          });
        }
        var group_pagination = div.querySelector(`${containerClassName} .group-pagination`);
        container.appendChild(group_pagination);
        document.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
          const newItem = div.querySelector(`[class="${item.className}"]`);
          if (!newItem)
            return;
          item.innerHTML = newItem.innerHTML;
        });
      });
    }
    loading() {
      this.classList.add("loading");
      if (!this.submitBtn.querySelector(".icon-loading")) {
        this.svgLoading = document.querySelector("#svg_loading svg")?.cloneNode(true);
        this.svgLoading.id = "loadingSVG";
        this.submitBtn.insertAdjacentElement("afterbegin", this.svgLoading);
      }
      this.submitBtn.toggleAttribute("disabled", true);
    }
  });
})();
